import React from 'react';
import Grid from '@mui/material/Grid';
import { Card, Box } from '@mui/material';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Container } from '@mui/material';

function Gallery() {
  return (
    <Container>
      <Grid container spacing={3} columns={4} >
        <Grid item md={2} >
          <Box margin={2} boxShadow={4} padding={4}>
            <Card>
              <CardContent>
                <a href='/gallery/terasz'><Typography variant="h5">Teraszfedés</Typography></a>
              </CardContent>
              <a href='/gallery/terasz'>
              <CardMedia component="img" src='./images/terasz.png' alt='Teraszfedés' ></CardMedia>              
              </a>
            </Card>
          </Box>
        </Grid>
        <Grid item md={2} >
          <Box margin={2} boxShadow={4} padding={4}>
            <Card>        
              <CardContent>
                <a href='/gallery/autobeallo'><Typography variant="h5">Autóbeállók</Typography></a>
              </CardContent>
              <a href='/gallery/autobeallo'>
                <CardMedia component="img" src='./images/autobeallo.png' alt='Autóbeállók' ></CardMedia>              
              </a>
            </Card>
          </Box>
        </Grid> 
        <Grid item md={2} >
          <Box margin={2} boxShadow={4} padding={4}>
            <Card >
              <CardContent>
                <a href='/gallery/teto'><Typography variant="h5">Tetőkarbantartás és fedés</Typography></a>
              </CardContent>
              <a href='/gallery/teto'>
              <CardMedia component="img" src='./images/tetofedes.png' alt='Tetőkarbantartás és fedés'></CardMedia>              
              </a>
            </Card>
          </Box>
        </Grid> 
        <Grid item md={2} >
          <Box margin={2} boxShadow={4} padding={4}>
            <Card>
              <CardContent>
                <a href='/gallery/konnyuszerkezetes'><Typography variant="h5">Könnyű szerkezetes házak</Typography></a>                
              </CardContent>
              <a href='/gallery/konnyuszerkezetes'>
              <CardMedia component="img" src='./images/ksz1.jpg' alt='Könnyű szerkezetes házak' ></CardMedia>              
              </a>
            </Card>
          </Box>
        </Grid> 
      </Grid>
    </Container>    
  );
}

export default Gallery;